import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { ProgramDtoService } from '../../../dto/program/program-dto.service';
import type { ProgramType, ProgramListDTO } from '@szebit-app/sdk/backend';
import { FadeInOnScrollDirective } from '../../../directives/fade-in-on-scroll.directive';
import { DatePipe } from '@angular/common';
import { UserStateSelectors } from '../../user/state/user-state-selectors';
import { select } from '@ngxs/store';
import { Router } from '@angular/router';
import { ExpandableTextComponent } from '../../common/expandable-text/expandable-text.component';
import { IsNilPipe } from '@pct-ng/common/pipe';

@Component({
  selector: 'app-programs',
  templateUrl: './programs.component.html',
  styleUrl: './programs.component.scss',
  imports: [FadeInOnScrollDirective, DatePipe, ExpandableTextComponent, IsNilPipe],
  providers: [ProgramDtoService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block home-block',
  },
})
export class ProgramsComponent {
  protected presentations: ProgramListDTO[] | null = null;
  protected workshops: ProgramListDTO[] | null = null;
  protected seminars: ProgramListDTO[] | null = null;
  readonly #router = inject(Router);
  readonly #service = inject(ProgramDtoService);
  readonly #canApply = select(UserStateSelectors.hasAccess('Company'));

  protected readonly isLoading = signal(true);
  protected readonly disableApplyy = signal(false); //valami belső névütközés van a 'disableApply'-al

  constructor() {
    this.#service.listPublicPrograms().subscribe(programs => {
      this.presentations = this.#sortProgramsByType(programs, 'Presentation');
      this.workshops = this.#sortProgramsByType(programs, 'Workshop');
      this.seminars = this.#sortProgramsByType(programs, 'Seminar');
      this.isLoading.set(false);
    });
  }

  protected onOpenApplyWorkshop(): void {
    if (this.#canApply()) {
      this.#router.navigate(['/apply-workshop']);
    } else {
      this.disableApplyy.set(true);
    }
  }

  protected onOpenApplySeminar(): void {
    if (this.#canApply()) {
      this.#router.navigate(['/apply-seminar']);
    } else {
      this.disableApplyy.set(true);
    }
  }

  #sortProgramsByType(programs: ProgramListDTO[], type: ProgramType): ProgramListDTO[] {
    return programs
      .filter(i => i.type === type)
      .sort((a, b) => {
        if (a.startAt === null) {
          return 1;
        }
        if (b.startAt === null) {
          return -1;
        }
        return a.startAt.localeCompare(b.startAt);
      });
  }
}
